import { render, staticRenderFns } from "./WceaCertificates.vue?vue&type=template&id=42f84a8c&scoped=true"
import script from "./WceaCertificates.vue?vue&type=script&lang=js"
export * from "./WceaCertificates.vue?vue&type=script&lang=js"
import style0 from "./WceaCertificates.vue?vue&type=style&index=0&id=42f84a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f84a8c",
  null
  
)

export default component.exports